import { Component, OnInit, OnDestroy, HostListener, ElementRef, Inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import 'rxjs/add/operator/filter';
import { SidebarService } from './sidebar.service';
import { AppSelectorService } from '../../shared/services/app-selector/app-selector.service';
import { FeatureSupportService } from 'src/app/shared/services/feature-support/feature-support.service';
import { DOCUMENT } from '@angular/common';
import { AmplitudeLoggerService } from 'src/app/shared/services/amplitude-logger/amplitude-logger.service';
import { AnalyticsEvents } from 'src/app/shared/constants/analytics-events';
import { DatacontextService } from 'src/app/data/datacontext.service';
import { FeatureListJsonService } from 'src/app/shared/services/config-manager/feature-list/feature-list-json.service';
import { EnvironmentManagerService } from 'src/app/shared/services/environment-manager/environment-manager.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  private appChangeListener: any;
  public disableSidebar;
  private subscription: Subscription;
  public openSidebarFlag = false;
  public disbaleMenuListNav = true;
  appLength = null;
  appsLoaded = false;
  public menuList = [{
    icon: {
      type: 'material',
      name: 'map',
    },
    route: '/context-builder/nudge-journeys',
    alias: 'nudge-im',
    title: 'Nudge Journeys',
    featureName: 'interaction_maps',
    parentFeature: 'sidebar',
    id: 'context-builder-nudge-journeys',
    isActive: false,
    separator: true,
    shouldBeHidden: false
  }, {
    icon: {
      type: 'material',
      name: 'layers'
    },
    route: '/actions/display-nudges',
    alias: 'nudge',
    title: 'Nudges',
    featureName: 'nudges',
    parentFeature: 'sidebar',
    id: 'actions-display-nudges',
    isActive: false,
    parentRoute: '/actions/display-nudges',
    shouldBeHidden: false,
    seperator: true,
  }, {
    icon: {
      type: 'material',
      name: 'device_hub',
      class: 'rotate-90'
    },
    route: '/context-builder/feature-management',
    alias: 'feature-im',
    title: 'Feature Management',
    featureName: 'interaction_maps',
    parentFeature: 'sidebar',
    id: 'context-builder-feature-management',
    isActive: false,
    shouldBeHidden: false
  }, {
    icon: {
      type: 'material',
      name: 'storage'
    },
    route: '/actions/product-variables',
    alias: 'temps',
    title: 'Product Variables',
    featureName: 'native_nudges',
    parentFeature: 'sidebar',
    id: 'actions-product-variables',
    isActive: false,
    parentRoute: '/actions/product-variables',
    shouldBeHidden: false,
    seperator: true,
  }, {
    icon: {
      type: 'material',
      name: 'filter_center_focus'
    },
    route: '/segments',
    alias: 'segs',
    title: 'User Segments',
    featureName: 'user_segments',
    parentFeature: 'sidebar',
    id: 'segments',
    isActive: false,
    shouldBeHidden: false
  }, {
    icon: {
      type: 'material',
      name: 'devices_other'
    },
    route: '/test-groups',
    featureName: 'test_devices',
    parentFeature: 'sidebar',
    alias: 'tgs',
    title: 'Test',
    id: 'test-groups',
    isActive: false,
    shouldBeHidden: false
  }];

  public currentUrl: string;
  public currentYear: number;
  public activeMenuItem: any;
  public plan: any;
  selectedApp: any = {
    os: ''
  };

  constructor(@Inject(DOCUMENT) private document: HTMLDocument,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sidebarService: SidebarService,
    private appSelectorService: AppSelectorService,
    private datacontextService: DatacontextService,
    private amplitudeLoggerService: AmplitudeLoggerService,
    private _elementRef: ElementRef,
    private environmentManagerService: EnvironmentManagerService,
    private featureSupportService: FeatureSupportService,
    private featureListJsonService: FeatureListJsonService) {
    this.currentYear = new Date().getFullYear();
    this.subscription = this.sidebarService.getHamburgerListener().subscribe(msg => {
      if (msg === 'open') {
        this.openSidebarFlag = true;
      } else if (msg === 'close') {
        this.openSidebarFlag = false;
      }
    });
    this.handleCallbackClickListener = this.handleCallbackClickListener.bind(this);
  }

  ngOnInit() {
    this.listenForAppChanges();
    this.getPlanForCompany();

    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((evt: NavigationEnd) => {
        this.handleSidebarChangesOnUrlChange((evt && evt.url) || '');
      });
    this.shouldMenuListBeHidden();
  }

  handleSidebarChangesOnUrlChange(url) {
    if (url) {
      this.disableSidebar = false;
      this.currentUrl = url;
      if (this.appsLoaded) {
        if (!this.appLength) {
          this.disableSidebar = true;
        }
      }
      this.disableSidebar = this.disableSidebar || ((
        url.includes('context-builder/journey-builder') ||
        url.includes('context-builder/nudge-journeys/journey-builder') ||
        url.includes('context-builder/feature-management/journey-builder') ||
        url.includes('context-builder/configure')) ? true : false);
      this.showHideSidebar(this.disableSidebar);
      // for home page we want to show home icon hence removing class d-none.
      if (url === '/' || url.includes('overview')) {
        const homeIcon: any = document.querySelector('.home-icon');
        homeIcon && homeIcon.classList && homeIcon.classList.remove && homeIcon.classList.remove('d-none');
      }
      this._setActiveRoute(url);
    }
  }

  toggleAppSelector() {
    this.sidebarService.toggleAppSelector();
  }

  shouldMenuListBeHidden() {
    this.menuList.forEach(menu => {
      this.featureListJsonService.shouldEnableTheFeature(`${menu.parentFeature}.${menu.featureName}`,
        'hidden', flag => menu.shouldBeHidden = flag);
    });
  }

  trackClick(cta, eventData) {
    const { eventName: { LEFT_PANEL_MENU_CLICK } } = AnalyticsEvents;
    this.amplitudeLoggerService.log(LEFT_PANEL_MENU_CLICK, cta, eventData);
  }

  getPlanForCompany() {
    this.appSelectorService.promisifyForAppData()
      .then(() => {
        const appList = this.appSelectorService.getApplist(this.environmentManagerService.getCurrentEnvironment());
        this.appLength = appList.length;
        this.appsLoaded = true;
        this.handleSidebarChangesOnUrlChange(this.router.url);
      });

    this.datacontextService.user.getUserCompany((res: any) => {
      const _companyDetails = res.api_response.companies[0];
      delete _companyDetails.apps;
      this.plan = _companyDetails.plan;
    });
  }

  listenForAppChanges() {
    this.appChangeListener = this.appSelectorService.getAppChangedListener().subscribe((appObj) => {
      this.selectedApp = appObj;

      this.menuList.forEach(function (item) {
        if (item.title === 'Test' && appObj && appObj.os === 'be') {
          item.title = 'User Groups';
        }
      }
      );
      this.shouldMenuListBeHidden();
      this.disbaleMenuListNav = false;
    });
  }

  ngOnDestroy() {
    if (this.appChangeListener) {
      this.appChangeListener.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }

    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.openSidebarFlag = false;
    }
  }

  showHideSidebar(hide) {
    const sidebar: any = this.document.querySelector('.sidebar') || { 'classList': '' };
    const routerOutletContainer: any = this.document.querySelector('.router-outlet-container') || { 'style': {} };
    const homeIcon: any = document.querySelector('.home-icon');
    const headerCont: any = document.querySelector('.header-cont');
    const subHeader: any = document.querySelector('.sub-header');
    if (hide) {
      sidebar.classList && sidebar.classList.add && sidebar.classList.add('d-none');
      routerOutletContainer.style['margin-left'] = 0;
      homeIcon && homeIcon.classList && homeIcon.classList.add && homeIcon.classList.add('d-none');
      if (headerCont) {
        headerCont.style['padding-left'] = 0;
      }
      if (subHeader) {
        subHeader.style['padding-left'] = '1.3em';
      }
    } else {
      sidebar.classList && sidebar.classList.remove && sidebar.classList.remove('d-none');
      routerOutletContainer.style['margin-left'] = '5em';
      homeIcon && homeIcon.classList && homeIcon.classList.remove && homeIcon.classList.remove('d-none');
      if (headerCont) {
        headerCont.style['padding-left'] = '5em';
      }
      if (subHeader) {
        subHeader.style['padding-left'] = '7.3em';
      }
    }
  }

  /**
  * Open the sidebar
  **/
  openSidebar() {
    // this.openSidebarFlag = !this.openSidebarFlag;
  }

  changeRoute(idx: number, alias: string) {// change route
    const { analyticsCtaMap } = AnalyticsEvents;
    this.trackClick(analyticsCtaMap[alias], {});
    if (this.router.url.split('?')[0] !== this.menuList[idx].route) {
      this.router.navigate([this.menuList[idx].route]).catch(err => {
        // Handle here
        window.history.pushState({}, document.title, this.menuList[idx].route);
        window.location.reload();
      });
    }
  }

  handleCallbackClickListener(featureName) {
    let featureArr = this.menuList.filter(menu => menu.featureName === featureName);
    let featureObject: any = {};
    if (featureArr.length) {
      featureObject = featureArr[0];
      if (featureObject.alias) {
        if (featureObject.alias in AnalyticsEvents.analyticsCtaMap) {
          this.trackClick(AnalyticsEvents.analyticsCtaMap[featureObject.alias], { disabled: true });
        } else {
          this.trackClick(featureObject.alias, { disabled: true });
        }
      }
    }
  }

  private _setActiveRoute(url: string) {
    this._makeAllRoutesInactive();
    this.sidebarService.closeSideBar();

    // find index of SB route item that has the current url
    const idx = this.menuList.findIndex((i) => {
      if (i['parentRoute']) {
        if (url.includes(i['parentRoute'])) {
          return url.includes(i['parentRoute']);
        }
      }
      return url.includes(i.route);
    });
    if (idx !== -1) {
      this._markAsActive(idx);
    }
  }

  private _markAsActive(idx: number) {
    this.menuList[idx].isActive = true;
    this.activeMenuItem = this.menuList[idx];
  }

  private _makeAllRoutesInactive() {
    this.menuList.forEach((item: any) => {
      item.isActive = false;
    });
  }
}
